import extractPageFromPath from "@ignitesales/neuro-application/src/page/extractPageFromPath";
import TagManager from 'react-gtm-module'

export const analyticEvents = {
  click: 'clickAction',
  findBranch: 'findBranch',
  accordionOpen: 'accordionExpansion',
  accordionClose: 'accordionClose',
  formComplete: 'formComplete'
};

const getPageName = path => {
  const page = extractPageFromPath(path);
  const removeDashes = s => s.replace(/-/g, '');
  if (page.type === 'survey') {
    return `${removeDashes(page.page.key)}`;
  } else {
    return `${page.type}`;
  }
};

export function processPageView(state) {
// gtm is configured to recognize and log history change triggers
}

export function processEvent({ event, data } = {}) {
  TagManager.dataLayer({
    dataLayer: {
      event,
      ...data
    }
  });
}

export function processConversionEvent({eventType, description} = {}) {}

  export function installAnalytics() {
    const propertyIdentifier = 'GTM-56MGNJ9';
    const tagManagerArgs = {
        gtmId: propertyIdentifier,
        events: {
          apply: 'Apply',
          addToCart: 'Add to Cart',
          addAllToCart: 'Add all to Cart',
          contact: 'Contact'
        }
    }
    console.log(`Installing and initializing google analytics: ${propertyIdentifier}`);
    TagManager.initialize(tagManagerArgs)
}
